// web-rnw twin of ./useAppActive.ts: a browser tab has no app lifecycle to
// follow, and the timers keep the behaviour they had before #325.
export function useAppActive(): boolean {
  return true;
}
